import { ErrorMessage } from "formik";

const FileInput = ({
  name,
  label,
  value,
  onChange,
  onRemove,
  error,
  touched,
  setPhoto,
  notRequired = false,
}) => (
  <div className="col-md-6 mb-3">
    <label
      className={`form-label ${!notRequired && "required-label"}`}
      htmlFor={name}
    >
      {label}
    </label>

    {value ? (
      <div className="tw-relative tw-w-full">
        <img src={value} alt={label} className="tw-w-1/2 tw-mx-auto" />
        <span
          onClick={() => {
            onRemove(name, onChange);
          }}
          className="tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-absolute tw-bg-red-500 tw-text-white tw-w-6 tw-h-6 tw-rounded-full -tw-right-2 -tw-top-2"
        >
          <span class="material-icons !tw-text-sm">close</span>
        </span>
      </div>
    ) : (
      <input
        type="file"
        name={name}
        className={`form-control ${
          touched && error ? "custom-invalid-input" : ""
        }`}
        onBlur={onChange}
        onChange={(event) => {
          const file = event.target.files[0];
          if (file) {
            const imageUrl = URL.createObjectURL(file);
            setPhoto(imageUrl);
            onChange(name, file);
          }
        }}
        accept=".pdf, .png, .jpg, .jpeg"
      />
    )}
    <ErrorMessage name={name} component="div" className="invalid-feedback" />
  </div>
);

export default FileInput;
